import React, { useCallback, useState } from 'react'
import { Row } from 'react-bootstrap'
import { useCart } from 'cart/CartProvider'
import SelectProductActions from './SelectProductActions'
import ProductListItemView from '../product_list_view/ProductListItemView'
import CartProductActions from '../cart_product_list/CartProductActions'
import { IProductBase, IProductInStore } from 'product/IProduct'
import { ICartOrder } from 'order_components/IOrder'

const productInCart = (cart: ICartOrder | null, product: IProductBase) => {
  if (cart) {
    return cart.products.find((product_) => product_.product_id === product.product_id)
  } else {
    return null
  }
}

interface IProductListForSelectProps {
  products: IProductInStore[]
}

const ProductListForSelect: React.FC<IProductListForSelectProps> = ({ products }) => {
  const [cart, cartAct] = useCart()
  const [isLoading, setIsLoading] = useState(false)

  // const selectActions = useCallback(
  //   (product: IProductBase) => {
  //     const cartProduct = productInCart(cart, product)
  //     if (cartProduct) {
  //       return <CartProductActions product={cartProduct} />
  //     } else {
  //       return <SelectProductActions product={product} />
  //     }
  //   },
  //   [cart]
  // )

  const handleAddProduct = useCallback(
    (product) => {
      setIsLoading(true)
      cartAct.addProduct(product, () => setIsLoading(false))
    },
    [cartAct]
  )

  const handleChangeProductOrder = useCallback(
    (product, quantity) => {
      setIsLoading(true)
      cartAct.changeProductQuantity(product, quantity, () => {
        setIsLoading(false)
      })
    },
    [cartAct]
  )

  const handleRemove = useCallback(
    (product) => {
      setIsLoading(true)
      cartAct.removeProduct(product, () => {
        setIsLoading(false)
      })
    },
    [cartAct]
  )

  return (
    <>
      {products.map((product) => (
        <Row key={product.product_id} className={'border-t-full py-row'}>
          <ProductListItemView product={product} showDescription='accordion'>
            {/* {selectActions(product)} */}

            {productInCart(cart, product) ? (
              <CartProductActions
                product={productInCart(cart, product)!}
                isLoading={isLoading}
                onRemoveProduct={handleRemove}
                onChangeProductQuantity={handleChangeProductOrder}
              />
            ) : (
              <SelectProductActions
                product={product}
                isLoading={isLoading}
                onAddToCart={handleAddProduct}
              />
            )}
          </ProductListItemView>
        </Row>
      ))}
    </>
  )
}
export default ProductListForSelect
